import React from 'react';

const Card = ({ character }) => {
    return (
        <div>
            <li className='card'>
                <img src={character.image}
                    onError={(e) => { e.target.onerror = null; e.target.src = "./img/main.jpg" }}
                />
                <div className="infos">
                    <h2>{character.name}</h2>
                    <p>{character.class}</p>
                    <p>{character.homeworld}</p>
                </div>
            </li >
        </div >
    );
};

export default Card;